import {
  fetchAgencyConsents,
  acceptAgencyConsent,
  cancelAgencyConsent,
  createAgencyConsent,
  fetchRetailersForConsent
} from '@/services/agencyConsent'

/**
 * Mutation types of the store
 */
export const mutationTypes = {
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED',
  FETCHING_RETAILERS: 'FETCHING_RETAILERS',
  FETCHED_RETAILERS: 'FETCHED_RETAILERS',
  UPDATING: 'UPDATING',
  UPDATED: 'UPDATED'
}

/**
 * Initial state
 */
const state = {
  fetching: false,
  updating: false,
  fetchingRetailers: false,
  agencyConsents: [],
  retailersForConsent: []
}

/**
 * Getters
 */
const getters = {
  actionableConsents: (state) => {
    return state.agencyConsents.filter((order) => {
      return order.status === 'PENDING' && order.initiatedByType === 'STORE'
    })
  }
}

/**
 * Actions
 */
const actions = {
  fetchAgencyConsents({ commit, dispatch }) {
    commit(mutationTypes.FETCHING)

    return fetchAgencyConsents()
      .then((response) => {
        commit(mutationTypes.FETCHED, response)
      })
      .catch(() => {
        commit(mutationTypes.FETCHED, [])
        dispatch(
          'notifications/addNotification',
          {
            color: 'error',
            text: 'Retailer Invites could not be loaded, try again...'
          },
          { root: true }
        )
      })
  },

  createAgencyConsent({ commit, dispatch }, storeIds) {
    commit(mutationTypes.UPDATING)

    return createAgencyConsent(storeIds)
      .then(() => {
        commit(mutationTypes.UPDATED)
        dispatch(
          'notifications/addNotification',
          {
            color: 'secondary',
            text: 'Retailer Invite successfully created!'
          },
          { root: true }
        )
      })
      .catch(() => {
        commit(mutationTypes.UPDATED)
        dispatch(
          'notifications/addNotification',
          {
            color: 'error',
            text: 'Retailer Invite could not be created, try again...'
          },
          { root: true }
        )
      })
      .finally(() => {
        dispatch('fetchRetailersForConsent')
        dispatch('fetchAgencyConsents')
      })
  },

  acceptAgencyConsent({ commit, dispatch }, consentId) {
    commit(mutationTypes.UPDATING)

    return acceptAgencyConsent(consentId)
      .then(() => {
        commit(mutationTypes.UPDATED)
        dispatch(
          'notifications/addNotification',
          {
            color: 'secondary',
            text: 'Retailer Invite successfully accepted!'
          },
          { root: true }
        )
      })
      .catch(() => {
        commit(mutationTypes.UPDATED)
        dispatch(
          'notifications/addNotification',
          {
            color: 'error',
            text: 'Retailer Invite could not be accepted, try again...'
          },
          { root: true }
        )
      })
      .finally(() => {
        dispatch('fetchRetailersForConsent')
        dispatch('fetchAgencyConsents')
      })
  },

  cancelAgencyConsent({ commit, dispatch }, consentId) {
    commit(mutationTypes.UPDATING)

    return cancelAgencyConsent(consentId)
      .then(() => {
        commit(mutationTypes.UPDATED)
        dispatch(
          'notifications/addNotification',
          {
            color: 'secondary',
            text: 'Retailer Invite successfully deleted!'
          },
          { root: true }
        )
      })
      .catch(() => {
        commit(mutationTypes.UPDATED)
        dispatch(
          'notifications/addNotification',
          {
            color: 'error',
            text: 'Retailer Invite could not be deleted, try again...'
          },
          { root: true }
        )
      })
      .finally(() => {
        dispatch('fetchRetailersForConsent')
        dispatch('fetchAgencyConsents')
      })
  },

  fetchRetailersForConsent({ commit, dispatch }) {
    commit(mutationTypes.FETCHING_RETAILERS)

    return fetchRetailersForConsent()
      .then((response) => {
        commit(mutationTypes.FETCHED_RETAILERS, response)
      })
      .catch(() => {
        commit(mutationTypes.FETCHED_RETAILERS, [])
        dispatch(
          'notifications/addNotification',
          {
            color: 'error',
            text: 'Retailers available for Retailer Invites could not be loaded, try again...'
          },
          { root: true }
        )
      })
  }
}

/**
 * Mutations
 */
const mutations = {
  [mutationTypes.FETCHING](state) {
    state.fetching = true
  },

  [mutationTypes.FETCHED](state, response) {
    state.fetching = false
    state.agencyConsents = response
  },

  [mutationTypes.UPDATING](state) {
    state.updating = true
  },

  [mutationTypes.UPDATED](state) {
    state.updating = false
  },

  [mutationTypes.FETCHING_RETAILERS](state) {
    state.fetchingRetailers = true
  },

  [mutationTypes.FETCHED_RETAILERS](state, response) {
    state.fetchingRetailers = false
    state.retailersForConsent = response
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
